import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import FactorySelectorBoxViewModelType from '@/ViewModels/Controls/FactorySelectorBoxViewModel';
import DropDownListType from '@/Controls/DropDownList';
import TextBoxType from '@/Controls/TextBox';

export default class FactorySelectorBox extends Control {

    private DropDownList = ComponentManager.getControl<typeof DropDownListType>('DropDownList');
    private TextBox = ComponentManager.getControl<typeof TextBoxType>('TextBox');
    private jQueryControl: JQuery;
    private dropDownList: DropDownListType;
    private textbox: TextBoxType;

    public constructor(private viewModel: FactorySelectorBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);


        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'factoryselectorbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    return states;
                }
            })
        });

        this.jQueryControl[0].style.display = "flex";

        if (this.viewModel.dropDownList != null) {
            this.dropDownList = new this.DropDownList(this.viewModel.dropDownList);
            let tuple = this.dropDownList.getTuple();

            tuple.control[0].style.flex = "1";
            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.textbox != null) {
            this.textbox = new this.TextBox(this.viewModel.textbox);
            let tuple = this.textbox.getTuple();

            tuple.control[0].style.flex = "1";
            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('FactorySelectorBox', FactorySelectorBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');